<template>
    <div class="notification" :class="[color]">
        <p class="no-space">
            <slot></slot>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'Notification',

        props: {
            color: String
        },
    }
</script>
